'use strict';

const responsiveBg = require('../../responsive-background');
const collectionIngredients = require('./collection-ingredients');
const multiCol = require('../../multi-col');
const highlight = require('./highlight');
const description = require('./description');
const video = require('../../video');
const productTile = require('../../product-tile');
const scrollOffset = 300;
const productFilter = require('../../product-filter');

const $filterBlockSelector = '.js-product-filter-block';

function initEvents(){
    // init general events
    $(document).on('click', '.js-collection-shop-all', function() {
        const collectionName = 'trigger-the-' + $(this).text().split(' ').pop().toLowerCase();
        let collection = null;
        if (document.querySelector('[data-anchor-id=' + collectionName + ']')){
            collection = document.querySelector('[data-anchor-id=' + collectionName + ']');
            productFilter.changeTab(collection);
        }
        $('html, body').animate({scrollTop: $(collection || '.js-product-grid-block').offset().top}, 800);
    });

    $(document).on('click', '.js-trigger-product-list-filter', function() {
        if ($filterBlockSelector.length == 0) {
            return;
        }

        const $this = $(this);
        const triggerName = $this[0].href.split('#').pop();
        if (!triggerName) {
            return;
        }

        let collection = null;
        if (document.querySelector('[data-anchor-id=' + triggerName + ']')){
            collection = document.querySelector('[data-anchor-id=' + triggerName + ']');
            productFilter.changeTab(collection);
        }
        $('html, body').animate({scrollTop: $('.js-product-grid-block').offset().top}, 800);
    });

    $('.js-samples-shop-all').on('click', function() {
        $('html, body').animate({scrollTop: $('.js-collection-cards-block').offset().top}, 800);
    });

    //Load product grid once we scroll past the navigation
    $(document).on('scroll.collectiongrid', function() {
        if ($(window).scrollTop() < scrollOffset) {
            return true;
        }

        $(document).off('scroll.collectiongrid'); //Only load once

        if ($('.js-grid-placeholder').length === 0) { //Only fire if there's a normal product grid in the page (i.e. not for "special" pages like Namaste)
            return;
        }

        let url = '';
        let data = {};
        const subCollectionUrl = $('.js-subcollection-product-grid-url');

        if (subCollectionUrl.length > 0) {
            url = subCollectionUrl.val();
            data = {
                format: 'ajax'
            };
        } else {
            url = Urls.productPartialGrid;
            data = {
                ritual: $('.js-collection-id').val(),
                source: 'collection'
            };
        }

        $.ajax({
            url: url,
            data: data,
            success: function (data) {
                if (!data) {
                    return;
                }

                $('.js-grid-placeholder').html(data).imagesLoaded(function() {
                    if (document.readyState === 'complete') {
                        initGrid();
                    } else {
                        $(window).on('load', function () {
                            initGrid();
                        });
                    }
                });
            }
        });
    });
}

function initGrid() {
    const grid = require('../../grid');
    grid.init();
    video.initGeneric();

    if ($('.js-grid-spinner').length) {
        $('.js-grid-spinner').removeClass('spinner-visible');
    }
}

const collection = {
    init: function() {
        initEvents();

        responsiveBg.init();
        collectionIngredients.init();
        multiCol.init();
        highlight.init();
        description.init();
        video.initGeneric();
        video.initCollection();
        productTile.init();
    }
};

module.exports = collection;
